import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setFiltersSorting, setAutoSortEnabled } from '@store/noc/base/actions';
import { fetchData } from '@store/noc/filtersData/actions';
import { NOC_REFRESH_INTERVAL } from '@utils/constants';
import { checkIfBrowserTabIsVisible } from '@src/hooks/useBrowserTabVisibility';
import { updatePopupVisibleSelector } from '@store/dashboards/ui/selectors';
import DataTable from '../common/DataTable';
import { tableDataSelector, columnsSelector } from './utils';
import { CheckIfUpdateDashboardPopupIsOpen } from '../common/utils';

function FilterTable() {
  const dispatch = useDispatch();

  const columns = useSelector(columnsSelector);
  const { data, sort } = useSelector(tableDataSelector);

  const onColumnSort = (sort: string) => {
    dispatch(setFiltersSorting(sort));
    dispatch(setAutoSortEnabled(false));
  };

  const updatePopupInfo = useSelector(updatePopupVisibleSelector);
  const isUpdatePopUpVisible = CheckIfUpdateDashboardPopupIsOpen(updatePopupInfo);

  useEffect(() => {
    dispatch(fetchData());
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      // do not do the 20 sec refresh if the user is on rt dashboard and update dashboard
      // popup is open as it rerenders the dialog box
      if (!isUpdatePopUpVisible && checkIfBrowserTabIsVisible()) {
        dispatch(fetchData());
      }
    }, NOC_REFRESH_INTERVAL);
    return () => {
      clearInterval(interval);
    };
  }, [columns, isUpdatePopUpVisible]);

  return <DataTable data={data} columns={columns} sort={sort} onColumnSort={onColumnSort} />;
}

export default FilterTable;
